/**
 * @desc 导出SKU物流信息列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.logisticsSupplierSkuFacadeImpl.exportList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/logisticsSku/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
